import Alert, { AlertProps } from '@mui/material/Alert';

export interface ErrorBlockProps extends AlertProps {
    error?: Error | string | null;
}

export function ErrorBlock({ error, children, ...rest }: ErrorBlockProps) {
    if (!error || error === null) {
        return null;
    }

    const errorContent = typeof error === 'string' ? error : error.message;

    return (
        <Alert severity="error" variant="filled" {...rest}>
            {children}
            {errorContent}
        </Alert>
    );
}
